import { Polygon } from 'react-leaflet'
import GridTileLayer from './GridTileLayer'
import { findCoords } from './plot.lib'

const MapData = ({ plots, selectedPlot = null /*, setSelectedPlot */ }) => {
    
    // const handlePlotClick = (e, id) => {
    // e.originalEvent.stopPropagation()
    
    // if (selectedPlot === id) {
    //     setSelectedPlot(null)
    // } else {
    // setSelectedPlot(id)
    // }
    // }
    
    
    return (
        <>
            <GridTileLayer />
            {plots.map(plot => 
                <Polygon
                    positions={findCoords(plot)}
                    key={plot.id}
                    // eventHandlers={{
                    //     click: e => handlePlotClick(e, plot.id),
                    // }}
                    pathOptions={{
                        color: plot.color,
                        fillOpacity: 0.1,
                        opacity: selectedPlot === null ? 0.5 : selectedPlot === plot.id ? 1 : 0.1,
                    }} />,
            )}
        </>
    )
}

export default MapData